module.exports = __webpack_public_path__ + "static/media/frontera-imlogo.521fa7dd.svg";